<template>
  <div id="materialvisial">
    <!--上传文件-->
    <el-dialog title="上传文件" :visible.sync="materialDialogVisible.upload" width="880px" :show-close="false" :close-on-click-modal="false" :append-to-body="appendToBody">
      <div class="material-site">
        <div class="uploadList">
          <div v-if="showUploadFileList.length">
            <el-row v-for="(site,index) in showUploadFileList" :key="index">
              <el-col  :span="12" :title="site.name"><span style="color: #0F0D11;font-size: 12px;font-weight: 500;padding-left: 5px">{{site.name}}</span></el-col>
              <el-col :span="6" ><span style="padding-left: 10px;color: #767484;font-size: 12px">{{site.size}}</span></el-col>
              <el-col  :span="6" v-show="site.percentage >= 100"><span style="font-weight: 400;color: #767484;font-size: 12px">已完成</span></el-col>
              <el-col  :span="6" v-show="site.percentage < 100"><span><el-progress type="circle" :percentage="site.percentage" color="#409eff" :width="35"></el-progress></span></el-col>
            </el-row>
          </div>
          <div slot="empty" v-else class="empty_material">
            <img src="@/assets/image/sources/table_no_data.png" alt="加载失败" />
            <p>暂无数据</p>
          </div>
        </div>
        <div class="m-upload">
          <el-form :model="materialForm" :rules="rules" ref="materialForm" label-width="88px">
            <el-form-item label=" 资源分类:" prop="categoryId">
              <el-select v-model="materialForm.categoryId" >
                <el-option
                  v-for="item in option1"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" 科目:" prop="subjectId" v-if="productFlag == 1 && courseModel == 2 ">
              <el-select v-model="materialForm.subjectId" @change="subjectChange" clearable>
                <el-option
                  v-for="item in subjectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="资源库分类:" prop="selectedOptions" v-show="isShowCascader && courseModel != 1">
<!--              <el-cascader-->
<!--                ref="cascader"-->
<!--                placeholder="全部"-->
<!--                :options="cascaderOptions"-->
<!--                v-model="materialForm.selectedOptions"-->
<!--                :props="{checkStrictly: true,expandTrigger: 'hover', label:'name', value: 'id'}"-->
<!--                filterable-->
<!--                clearable-->
<!--                show-all-levels-->
<!--                popper-class="mycascader"-->
<!--              >-->
<!--              </el-cascader>-->
              <el-popover
                placement="bottom"
                width="300"
                trigger="focus">
                <el-tree
                  style="max-height: 200px;overflow-y: auto"
                  ref="treeList"
                  :data="cascaderOptions"
                  check-strictly
                  show-checkbox
                  node-key="id"
                  :default-expanded-keys="[]"
                  :default-checked-keys="[]"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  @check-change="handleCheckChange"
                >
                </el-tree>
                <el-input :value="materialForm.selectedOptions" slot="reference" readonly placeholder="请选择" suffix-icon="el-icon-caret-bottom"></el-input>
              </el-popover>
            </el-form-item>
            <el-form-item
              label="选择文件:"
              prop="materialUpload"
            >
              <div style="display: flex">
                <el-upload
                  ref="addUpload"
                  :action="materialForm.upload.url"
                  :data="materialForm.upload.data"
                  :headers="headers"
                  :show-file-list="false"
                  :with-credentials="true"
                  :on-success="handleAvatarSuccess"
                  :on-error="handleAvatarError"
                  :before-upload="beforeAvatarUpload"
                  :on-progress="uploadProgress"
                  :on-preview="handlePreview"
                  multiple
                >
                  <div class="el-upload__text"><img src="@/assets/image/sources/add.png" alt=""></div>
                </el-upload>
                <div class="text-p">
                  <div class="el-upload__tip" slot="tip">
                    <p class="tis-p">PPT：.ppt .pptx<br/><span> 文档：.doc .docx .pdf</span> <br/><span> 图片：.png .jpg .jpeg</span> <br/><span>视频：.mp4 .asf .mpg .3gp .mov .avi .flv</span><br/> <span>音频：.mp3 </span> <br/><span>其他：.xls .xlsx .zip .rar</span></p>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeHeadlesubmitForm">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 删除素材弹框 -->
    <el-dialog
      title="删除素材"
      :visible.sync="materialDialogVisible.delete"
      width="420px"
      :before-close="handleDeleteDialogClose">
      <span>正在删除素材 {{materialForm.materialName}}</span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDeleteDialogClose('materialForm')">取 消</el-button>
        <el-button type="primary" @click="confirmDelete('materialForm')">确认删除</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
    import bus from "@/vendor/eventbus";
    import * as api from '@/api/sourceApi'
    import {formatTime} from "@/utils/utils.js";
    import leftTree from "@/components/leftTree.vue"
    export default {
        name: "uploadMaterial",
        components:{
            leftTree,
        },
        data() {
            return {
                defaultProps: {
                  children: 'children',
                  label: 'name'
                },
                subjectId: sessionStorage.getItem('subjectId') || this.defaultSubjectId,
                categoryId: "", //资源分类id
                isShow: false,
                loading: false,
                //添加素材参数
                materialForm: {
                    categoryId: "",
                    selectedOptions: '',
                    id:"",
                    materialsort: "",
                    materialPic: "",
                    uploader:"",
                    uploadTime:"",
                    upload:{
                        url: this.isShareResource ? `${process.env.UPLOAD_NAME}/sharedResourceUpload/uploadFile` : `${process.env.UPLOAD_NAME}/resourceUpload/uploadFile`,
                        data:{
                        },
                        type:""
                    },
                    uploadRes:{

                    },
                    subjectId: this.$route.query.subjectId ? Number(this.$route.query.subjectId) : '', // 有科目 直接默认科目 没有就是默认空
                },
                //查看
                materialViewDialog: {
                    type: 0,
                    url: "",
                },
                isTreeShow: false,
                tableData3: [],
                materialId: null,
                cascaderOptions: [],
                selectedOptions: '',
                option1: [],
                value: '',
                //条件查询
                conditionList: {
                    //素材名称
                    materialName: "",
                    materialType: "",
                    materialstate: "",
                    userPhoneOrName: "",
                    materialTypes: [
                        { value: "1", label: "图片" },
                        { value: "2", label: "文档" },
                        { value: "3", label: "音频" },
                        { value: "4", label: "视频" },
                        { value: "5", label: "zip" },
                    ],
                    materialSubjectNames: [],
                    materialSubjectName: "",
                    materialObjData:{},
                },
                //分页数据
                page: {
                    pageSize: 10,
                    pageNum: 1,
                    total: 0,
                },
                showUploadFileList: [],
                percentage:'',
                rules: {
                    categoryId: [
                        { required: true, message: "请选择资源分类", trigger: "change" },
                    ],
                    // selectedOptions: [
                    //     { required: true, message: "请选择资源库分类", trigger: "change" },
                    // ],

                    materialPic: [{ required: true, message: "上传", trigger: "change" }],
                    formLabelWidth: "120px",
                    imageUrl: "",
                    height: window.innerHeight - 245 + "px" // 表格高度根据窗口高度来决定
                },
                formLabelWidth: "120px",
                imageUrl: require("@/assets/image/sources/wenjianjia.png"),
                productFlag: sessionStorage.getItem("productFlag"), // 产品：1、书证融通，2、单项训练，3、综合实训，4、真实任务, 5、新真实任务
                courseModel: this.$route.query.courseModel || '', // 产品模式 1标准 2产品
                query: {},
            };
        },
        props: {
            materialDialogVisible: {
                type: Object,
                default: {}
            },
            isShowCascader: {
              type: Boolean,
              default: true
            },
            isShareResource: {
              type: Boolean,
              default: false
            },
            isInner:{
                type: Boolean,
                default: false
            },
            courseId: [Number, String],
            appendToBody: {
              type: Boolean,
              default: false
            },
            defaultSubjectId: [Number, String],
            subjectList: {
              type: Array,
              default: () => []
            }
        },
        computed: {
            // ...mapState({
            //     floaterTag: (state) => state.app.floaterOpened,
            // }),

            headers() {
                return {
                    Authorization: "bearer " + localStorage.getItem("Authorization"),
                    orgId: sessionStorage.getItem('deptId'),
                    subjectId: this.$route.query.subjectId || this.materialForm.subjectId,
                    materialId: this.materialId,
                    categoryId: this.materialForm.categoryId   //资源分类id
                }
            },
            contentHeight() {
                if (this.tableData3.length && this.page.total > this.page.pageSize) {
                    return window.innerHeight - 190 + "px";
                } else {
                    return window.innerHeight - 180 + "px";
                }
            },
        },
        created() {
          if (this.$route.query.query) {
            this.query = JSON.parse(this.$AES.AES_Decrypt(this.$route.query.query))
            this.courseModel = this.courseModel || this.query.courseModel
          }
         },
        beforeDestroy() {},
        watch:{
            'materialDialogVisible.upload'(newVal){
                if(!newVal){
                    this.showUploadFileList = []
                    this.materialForm.categoryId = this.option1.find(item => item.categoryName === "其它") ? this.option1.find(item => item.categoryName === "其它").id : ''; // 默认 其它
                    this.selectedOptions = ''
                    this.cascaderOptions = []
                }else{
                    this.$nextTick(()=>{
                        this.$refs['materialForm'].clearValidate()
                    })

                }
            },
            // 'defaultSubjectId'(val) {
            //   if(val) {
            //     this.subjectId = val;
            //     this.materialForm.subjectId = val;
            //     this.init()
            //   }
            // }
        },
        mounted() {
            // if (!this.floaterTag) {
                this.init(); // 初始化
            // }
            this.findResCategoryByCourseId(this.courseId ? this.courseId : this.$route.query.id || this.$parent.query.id);
        },
        methods: {
            subjectChange() {
              this.materialForm.selectedOptions = '';
              this.materialId = null;
              this.$refs.treeList.setCheckedKeys([],true)
              this.getMaterialTreeListById()
            },
            init() {
                this.materialObjData={};
                // this.cascaderOptions = formatData(parma.materials)
                this.cascaderOptions = []
                // this.selectedOptions= parma.arrIds;
                // this.materialForm.upload.data.materialId = parma.id;
                this.getMaterialTreeListById()
                // api.getMaterialTreeListById(this.$route.query.subjectId).then(res =>{
                //     console.log(res)
                //     if (res.code == 0) this.cascaderOptions = res.data.materials
                // })
            },
            // 获取列表
            getMaterialTreeListById() {
                this.cascaderOptions = [];
                if (!this.$route.query.subjectId && !this.materialForm.subjectId) {
                  return
                }
                api.getMaterialTreeListById(this.$route.query.subjectId || this.materialForm.subjectId).then((res) => {
                    if (res.code == 0) {
                        this.cascaderOptions = this.getTreeData(res.data.materials);
                    }
                });
            },
            // 解决el-cascader控件 最后一级暂无数据仍然显示。
            //递归判断列表，把最后的child设为undefined
            getTreeData(data,position) {
              for (let i = 0; i < data.length; i++) {
                    data[i].parentPosition = `${position == null ? data[i].name : position + '/' + data[i].name}`
                    if (data[i].children.length < 1) {
                        // child若为空数组，则将child设为undefined
                        data[i].children = undefined;
                    } else {
                        // child若不为空数组，则继续 递归调用 本方法
                        this.getTreeData(data[i].children,data[i].parentPosition);
                    }
                }
                return data;
            },

            // 树选择
            materialSubjectNameChange() {
                this.$refs.leftTree.treeList(this.conditionList.materialSubjectName);
            },
            showList(id, subjectId, isTreeShow) {
                if (isTreeShow) {
                    this.loading = true;
                    this.materialId = id;
                    this.isTreeShow = isTreeShow;
                    this.subjectId = subjectId || this.$parent.$route.query.subjectId;
                    this.page.pageSize = 10;
                    this.page.pageNum = 1;
                    this.postgetResourceLists();
                } else {
                    this.page.pageSize = 10;
                    this.page.pageNum = 1;
                    this.loading = true;
                    this.materialId = "";
                    this.isTreeShow = isTreeShow;
                    this.subjectId = subjectId || this.$parent.$route.query.subjectId;
                    this.postgetResourceLists();
                }
            },
            tableSelect(data) {
                this.multipleSelection = data;
                this.tableIds = data.map((x) => x.id);
            },
            queryPostCollegeLists() {
                this.page.pageSize = 10;
                this.page.pageNum = 1;
                this.postgetResourceLists();
            },

            closeViewDialog() {
                this.materialDialogVisible.view = false;
                this.materialDialogVisible.edit = false;
                //如果是视频则暂停
                if (this.materialViewDialog.type == 4) {
                    if (this.$refs.video) {
                        this.$refs.video.pause();
                    }
                }
                this.emptyParam();
            },
            // 查看
            handlesee(row) {
                if (row.type == 5) {
                    this.handlegetZip(row.newAttaUrl);
                } else {
                    this.$router.push({
                        name: "material-details",
                        params: { id: row.id, type: row.type, filePath: row.newAttaUrl },
                    });
                }
            },
            formatCreateTime(item) {
                if (!item || !item.createTime) return "";
                var date = new Date(item.createTime);
                var fmt = "yyyy-MM-dd";
                var o = {
                    "M+": date.getMonth() + 1, //月份
                    "d+": date.getDate(), //日
                    "h+": date.getHours(), //小时
                    "m+": date.getMinutes(), //分
                    "s+": date.getSeconds(), //秒
                    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
                    S: date.getMilliseconds(), //毫秒
                };
                if (/(y+)/.test(fmt))
                    fmt = fmt.replace(
                        RegExp.$1,
                        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
                    );
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt))
                        fmt = fmt.replace(
                            RegExp.$1,
                            RegExp.$1.length == 1
                                ? o[k]
                                : ("00" + o[k]).substr(("" + o[k]).length)
                        );
                return fmt;
            },
            selectable(row) {
                if (row.transcodeStatus == 2 || row.transcodeStatus == 3) {
                    return false;
                }
                return true;
            },
            headleresetForm() {
                //清空参数
                this.emptyParam();
                //关闭弹框
                this.materialDialogVisible.add = false;
            },
            //删除弹框
            deleteMaterial(row){
                this.materialForm.materialName = row.name;
                this.materialForm.id = row.id;
            },
            //确认删除
            confirmDelete(){
                let id = this.materialForm.id;

                this.$ajax.delete(`/cjdd-resources/resourses/delete/material/attachment/one?id=${id}`).then(res =>{
                    console.log(res);
                    // this.materialData=res;
                    if(res.data.code==0){
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.emptyParam();
                        this.$parent.postgetResourceLists();
                        this.materialDialogVisible.delete=false;
                    }
                }).catch(error=>{
                    console.log(error);
                });
            },

            //取消删除
            handleDeleteDialogClose(){
                this.emptyParam();
                this.materialDialogVisible.delete=false;
            },
            // 上传查询资源分类
            findResCategoryByCourseId(id) {
                api.FindResCategoryByCourseId(id).then(res => {
                    if (res.code == "0") {
                        let data = res.data;
                        // data.unshift({
                        //     categoryName: "全部",
                        //     courseId : ""
                        // })
                        this.option1 = data;
                        this.materialForm.categoryId = this.option1.find(item => item.categoryName === "其它") ? this.option1.find(item => item.categoryName === "其它").id : ''; // 默认 其它
                    } else {
                        this.$message.error(res.msg);
                    }
                }).catch(err=>{
                    console.log(err);
                })
            },
            // 上传文件关闭
            closeHeadlesubmitForm(){
                this.$refs.treeList.setCheckedKeys([],true)
                this.materialDialogVisible.upload = false;
                this.$emit("closeDialog");
                // bus.$emit("resourseInit");
                this.$emit("updateKey")
                this.emptyParam();
                try {
                  if (this.$parent.$refs['pages']) {
                    this.$parent.$refs['pages'].currentPage = 1
                  }
                  this.$parent.page.pageNum = 1
                  if (this.$parent.postgetResourceLists) {
                    this.$parent.postgetResourceLists();
                  }
                  if(this.isInner){
                    this.$parent.initList()
                  }
                }catch (e) {

                }

            },
            //上传文件移除
            handleRemove(file, fileList) {
                this.showUploadFileList = this.showUploadFileList.filter(x => x.uid!=file.uid);
            },
            handleAvatarError(err, file, fileList) {
                console.log(err)
                console.log(file)
                console.log(fileList)
            },
            handleAvatarSuccess(res, file) {
                // console.log(res, file,1111111111111)
                if (res.code == 0) {
                    //文件上传成功判断素材名称是否填写
                    this.materialForm.materialUpload = "success";
                    let materialId = this.materialObjData.materialId;
                    let subjectId = this.$route.query.id || this.$parent.$route.query.subjectId;
                    //上传完成进度设置成100%
                    let {data:{createTime}} = res;
                    // console.log(formatTime(createTime,"yyyy-MM-dd hh:mm:ss"),createTime)
                    this.showUploadFileList.forEach(item =>{
                        if(item.uid ==file.uid){
                            this.$set(item,'percentage',Number.parseInt(100))
                            this.$set(item,'createTime',formatTime(createTime,"yyyy-MM-dd hh:mm:ss"))
                        }
                    })
                    // console.log(materialId,subjectId,"22222222222222222")
                    bus.$emit("showLists", materialId,subjectId);
                    console.log(11);
                    //将每个结果对象放到数组
                    this.$refs["materialForm"].clearValidate();

                } else {
                    // console.log(res, file,2222222222222)
                    let fileId = file.uid;
                    this.showUploadFileList.forEach(item =>{
                        // if(item.uid == fileId){
                        //     item.state="上传失败";
                        // }
                    })
                    // this.$message.error("格式不支持上传")
                    this.$message.error(res.msg)
                }
            },

            getfilesize(size) {
                if (!size)
                    return "";

                var num = 1024.00; //byte

                if (size < num)
                    return size + "B";
                if (size < Math.pow(num, 2))
                    return (size / num).toFixed(2) + "KB"; //kb
                if (size < Math.pow(num, 3))
                    return (size / Math.pow(num, 2)).toFixed(2) + "MB"; //M
                if (size < Math.pow(num, 4))
                    return (size / Math.pow(num, 3)).toFixed(2) + "GB"; //G
                return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
            },
            headlesubmitForm(){
                let materialId = this.$store.getters["material/getMaterialObj"].id;
                //素材节点 id
                this.materialForm.uploadRes.materialId = materialId;
                //素材名称 name
                this.materialForm.uploadRes.name = this.materialForm.materialName;

                console.log(this.materialForm.uploadRes);

                this.$ajax.post(`/cjdd-resources/resourses/insert/material/attachment/one`,this.materialForm.uploadRes).then(res =>{
                    console.log(res);
                    if(res.data.code==0){
                        //清空参数
                        this.emptyParam();
                        //关闭弹框
                        this.materialDialogVisible.add = false;

                        this.$parent.postgetResourceLists();

                    }else{
                        this.$message.error("添加素材错误！")
                    }

                }).catch(error=>{
                    console.log(error);
                });
            },

            //添加素材上传 准备参数
             beforeAvatarUpload(file, fileList){
                let isUpload = false
                let as1 = this.$refs['materialForm'].validate((valid) => {
                    if (valid) {
                        isUpload = true
                    }
                });
                if(!isUpload) return false
                let userId = sessionStorage.getItem("userId");
                let orgId = localStorage.getItem("deptId");
                let materialName = "";
               // this.$set(this.headers, 'subjectId', this.$route.query.id)
               if(!this.headers.materialId && !this.headers.subjectId){
                 // materialName="全部";
                 this.$delete(this.headers,'materialId')
                 this.$delete(this.headers,'subjectId')
                 // this.$set(this.headers, 'subjectId', this.materialObjData.id)
               } else {
                 // let  materialId = this.$refs['cascader'].getCheckedNodes(false)[0].value;
                 // materialName = this.$refs['cascader'].getCheckedNodes(false)[0].label;
                 // this.$set(this.headers, 'materialId', materialId)
                 // this.$set(this.headers, 'subjectId', sessionStorage.getItem('subjectId') || this.materialForm.categoryId)
                 // this.$set(this.headers, 'subjectId', this.materialObjData.id)
               }
                this.$set(this.headers, 'userId', userId)
                // this.$set(this.headers, 'orgId', orgId)
                 console.log(file)
                let fileSize = file.size;
                let name = file.name;
                if (name.length > 200) {
                    this.$message.warning("名字长度过长,请重新选择");
                    return;
                }

                let suffix = name.substring(name.lastIndexOf(".") + 1);
                let docArr = ["docx","DOCX","doc", "DOC", "ppt", "PPT", "pptx", "PPTX", "pdf", "PDF", "xls", "xlsx", "XLSX", ];
                let auditArr  = ["mp4","MP4","avi","AVI","asx","ASX","asf","ASF","mpg","MPG","3gp","3GP","mov","MOV","avi","AVI","flv","FLV"]
                if (docArr.indexOf(suffix) != -1) {
                    if (fileSize > 1048576000) {
                        this.$message.warning("上传文件不能大于1G");
                        return;
                    }
                    //上传类型 2 文档
                    this.materialForm.upload.type = 2;
                    let {name,size,uid} =file;
                    let obj = {name,size: this.getfilesize(size),uid,state:"上传中",img:require('@/assets/image/sources/wenjian.png'),materialName,file};
                    this.showUploadFileList.unshift(obj);


                } else if (auditArr.indexOf(suffix) != -1) {
                    if (fileSize > 2147483648) {
                        //2147483648 2G
                        this.$message.warning("上传视频文件不能大于2G");
                        return;
                    }

                    //上传类型 4  视频
                    this.materialForm.upload.type = 4;
                    let {name,size,uid} =file;
                    let obj = {name,size: this.getfilesize(size),uid,state:"上传中",img:require('@/assets/image/sources/shipin1.png'),materialName,file};
                    this.showUploadFileList.unshift(obj);

                } else if (suffix == "mp3") {
                    if (fileSize > 31457280) {
                        //31457280 2G
                        this.$message.warning("上传音频文件不能大于30M");
                        return;
                    }

                    //上传类型 3  音频
                    this.materialForm.upload.type = 3;
                    let {name,size,uid} =file;
                    let obj = {name,size: this.getfilesize(size),uid,state:"上传中",img:require('@/assets/image/sources/yinpin.png'),materialName,file};
                    this.showUploadFileList.unshift(obj);
                } else if (suffix == "jpg" || suffix == "png" || suffix == "jpeg") {
                    if (fileSize > 10485760) {
                        //104857600 10M
                        this.$message.warning("上传图片不能大于10M");
                        return;
                    }
                    //上传类型 1  图片
                    this.materialForm.upload.type = 1;
                    let {name,size,uid} =file;
                    let obj = {name,size: this.getfilesize(size),uid,state:"上传中",img:require('@/assets/image/sources/tupian1.png'),materialName,file};
                    this.showUploadFileList.unshift(obj);
                } else if (suffix == "zip" || suffix == "rar") {
                    if (fileSize > 2147483648) {
                        //104857600 100M
                        this.$message.warning("上传压缩包不能大于2G");
                        return;
                    }
                    this.materialForm.upload.type = 5;
                    this.materialForm.upload.data.savepath = "course_res_/socialTraining/";
                    let {name,size,uid} =file;
                    let obj = {name,size: this.getfilesize(size),uid,state:"上传中",img:require('@/assets/image/sources/zip.png'),materialName,file};
                    this.showUploadFileList.unshift(obj);
                }
            },
            uploadProgress(event, file) {
                let uid = file.uid;
                this.showUploadFileList.forEach(item =>{
                    if(item.uid ==uid){
                        this.$set(item,'percentage',Number.parseInt(file.percentage))
                        // item.percentage=;
                        // if(file.type == 'reload'){
                        //     this.$set(item,'state','正在上传')
                        // }
                    }
                })
            },
            // 文件上传
            handlePreview(file) {
                console.log(file);
            },

            viewMaterial(row){
                this.$ajax.get(`/cjdd-resources/resourses/get/material/attachment/one?id=${row.id}`).then(res =>{
                    console.log(res);
                    if(res.data.code==0){
                        this.materialForm.materialName = res.data.data.name;
                        this.materialForm.materialsort = res.data.data.classify;
                        //TODO 未完成
                        // this.materialForm.materialName = res.data.data.newAttaUrl;
                        this.materialForm.uploader = res.data.data.uploader;
                        this.materialForm.uploadTime = res.data.data.createTime;

                        if(row.type && row.type==1){
                            this.imageUrl =require("@/assets/image/sources/picture.png");
                        }else if(row.type && row.type==2){
                            this.imageUrl =require("@/assets/image/sources/pptpdf.png");
                        }else if(row.type && row.type==3){
                            this.imageUrl =require("@/assets/image/sources/yinpin.png");
                        }else if(row.type && row.type==4){
                            this.imageUrl =require("@/assets/image/sources/video.png");
                        }

                    }
                }).catch(error=>{
                    console.log(error);
                });
            },
            emptyParam(){
                this.materialForm = {
                    id:"",
                    materialName: "",
                    materialsort: "",
                    materialPic: "",
                    uploader:"",
                    uploadTime:"",
                    upload:{
                        url: this.isShareResource ? `${process.env.UPLOAD_NAME}/sharedResourceUpload/uploadFile` : `${process.env.UPLOAD_NAME}/resourceUpload/uploadFile`,
                        data:{
                        },
                        type:""
                    },
                    uploadRes:{

                    },
                    categoryId: "",
                }
                this.imageUrl=require("@/assets/image/sources/wenjianjia.png")
            },
          handleCheckChange(data, checked, tree) {
            console.log('data',data)
            console.log('checked',checked)
            console.log('tree',tree)
            if (checked) {
              this.materialForm.selectedOptions = String(data.parentPosition)
              this.$set(this, 'materialId', data.id)
              this.$refs.treeList.setCheckedKeys([data.id],true)
            }else if(this.materialId === data.id){
              this.materialForm.selectedOptions = ''
              this.materialId = null
            }
          },
          getParentTree(list){
              list.forEach(item=>{
                item.children&&this.getParentTree(item.children)
              })
          }
        }
    }
</script>

<style scoped lang="scss">
    /deep/ .el-select .el-input .el-select__caret{
      height: inherit;
    }

  .material-management-warp{
    /*display: flex;*/
    .material_preview_dialog_left {
      width: 560px;
      height: 462px;
      background: #eeeeee;
      box-sizing: border-box;
      position: relative;

      .viewcontainer {
        width: 560px;
        height: 430px;
        overflow-x: hidden;
        overflow-y: auto;
        .img_wrap {
          width: 560px;
          height: 430px;
          position: relative;

          img {
            max-width: 100%;
            max-height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            margin: auto;
          }
        }
      }
    }
    .main-box{
      width: 70%;
      float: right;
      .material-aside{
        width:18%;
        height:518px;
        border:1px solid rgba(235,235,235,1);
        border-radius:4px;
        float: left;
        overflow: auto;
        background: white;
      }
      .material_main{
        width: 100%;
        background: #f0f3fa ;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        height: 45px;
        line-height: 45px;
        border-radius: 4px;
        .material-item{
          height: 40px;
          border-radius: 4px 4px 0px 0px;
          display: flex;
          .item-header{
            width: 100%;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            display: -webkit-box;
            display: inline-block;
            padding-left: 10px;
            .el-input{
              width: auto;
              margin-right: 10px;
            }
            .material_name{
              .el-input__inner{
                width: 160px ;
                height:30px;
                border-radius:4px;
                color:rgba(153,153,153,1);
              }
              .el-input__icon{
                height:30px;
              }
            }
            .el-select{
              width: auto;
            }
            .el-input--suffix .el-input__inner{
              width:160px;
              height:30px;
              line-height: 30px;
              border-radius:4px;
              .el-input__icon{
                line-height: 30px!important;
              }
            }
            .el-input__icon{
              line-height: 30px!important;
            }
            .material_tel input{
              width:200px;
              height:30px;
              border-radius:4px;
            }
            .material-query{
              width: 72px;
              height: 30px;
              line-height: 30px;
              padding: 0;
              color: #5397F7;
              border: 1px solid #5397f7;
              font-size: 12px;
              margin-top: 8px;
              &:hover{
                width: 72px;
                height: 30px;
                line-height: 30px;
                padding: 0;
                background:rgba(83,151,247,.8);
                border:1px solid rgba(83,151,247,.8);
                color:rgba(255,255,255,1);
                font-size: 12px;
              }
            }
            .material-examine{
              width: 80px;
              height: 30px;
              line-height: 30px;
              padding: 0;
              color: #5397F7;
              border: 1px solid #5397f7;
              font-size: 12px;
              &:hover{
                width: 80px;
                height: 30px;
                line-height: 30px;
                padding: 0;
                background:rgba(83,151,247,.8);
                border:1px solid rgba(83,151,247,.8);
                color:rgba(255,255,255,1);
                font-size: 12px;
              }
            }
            .add-material{
              width: 80px;
              height: 30px;
              line-height: 30px;
              padding: 0;
              color: #5397F7;
              border: 1px solid #5397f7;
              font-size: 12px;
              margin: 0;
              &:hover{
                width: 80px;
                height: 30px;
                line-height: 30px;
                padding: 0;
                background:rgba(83,151,247,.8);
                border:1px solid rgba(83,151,247,.8);
                color:rgba(255,255,255,1);
                font-size: 12px;
              }
            }

          }
        }
      }
      .material-item-right{
        height: calc(100vh - 100px);
        margin-top: 10px;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        overflow-y: auto;
        border-radius: 4px;
        padding: 0px 5px;
      }
    }
    .isShow {
      width: 0;
      opacity: 0;
      transition: all 0.3s ease-in-out;
    }
    .material_management_title{
      height: 48px;
      border-bottom: 1px solid #5397F7;
      display: flex;
      align-items: center;
    }
    .demo-form-inline{
      display: flex;
      float: left;
    }
    /deep/ .material-item-right .material_search .material_type {
      width: 100px;
      margin-right: 16px;
    }

    .add_material_btn{
      width: 32px;
      height: 32px;
      position: absolute;
      right: 0;
      top: 0;
      text-align: center;
      line-height: 32px;
      font-size: 16px;
      color: #fff;
      cursor: pointer;
    }
    .material-content-table{
      border-radius:4px;
      cell> span{
        color: pink;
      }
    }
    .el-message-box{
      width:420px!important;
      height:240px!important;
      background:rgba(255,255,255,1)!important;
      border-radius:8px;
    }
    .t-user-modify-tree{
      &.t-tree{
        .el-tree-node{
          .is-leaf + .el-checkbox .el-checkbox__inner{
            display: inline-block
          }
          .el-checkbox__input>.el-checkbox__inner{
            display: none
          }
        }
      }
    }
    .empty_material{
      text-align: center;
      img{
        width: 140px;
        height: 140px;
        margin-top: 100px;
      }
      p{
        font-size:14px;
        font-weight:400;
        line-height:16px;
        color:#999999;
      }
    }

  }
  .material-site{
    display: flex;
    .uploadList{
      width: 50%;
      line-height: 48px;
      height: 250px;
      overflow-y: auto;
      /deep/ .el-progress .el-progress--circle .el-progress-circle{
        width: 40px;
        height: 40px;
        .el-progress__text{
          font-size: 10px;
        }
      }
      .empty_material{
        text-align: center;
      }
      .el-row:nth-child(odd){
        background:#F5F5F7;
        border-radius:2px;
      }
      .el-row{
        width: 98%;
        height: 48px;
        line-height: 48px;
        padding: 0px 5px;
        .el-col{
          color: #0D0D0D;
          font-size: 12px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          height: 48px;
          span{
            color: #9498A3;
            font-size: 12px;
            padding-right: 6px;
          }
          img{
            vertical-align: middle;
            padding-right: 6px;
            width: 24px;
          }
          em{
            font-style: normal;
            padding-right: 8px;
            display: inline-block;
          }
          .dataTime{
            color: #0D0D0D;
            font-size: 12px;
            padding-left: 10px;
          }
          .el-progress{
            line-height: 4;
            padding-top: 7px;
          }
          .el-progress__text{
            font-size: 10px!important;
          }
        }
      }
      .empty_material{
        img{
          display: inline-block;
          width: 187px;
          height: 159px;
        }
        p{
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #767484;
        }
      }
    }
    .m-upload{
      width: 50%;
    }
    .el-upload {
      width: 72px;
      height: 72px;
      border-radius: 3px;
      line-height: 28px;
      text-align: left;
      background:rgba(213,218,237,1);
      margin-top: 8px;
    }
    .el-upload__text{
      padding: 15px;
      color: #D5DAED;
      font-size: 12px;
    }

    .m-upload{
      /deep/ .el-input--suffix {
        width: 300px;
        height: 32px;
      }
      .text-p{
        padding-left: 10px;
        .el-upload__tip{
          padding-top: 0px;
        }
        .tis-p{
          color: #999;
          font-size: 12px;
          line-height: 20px;
        }
      }
    }
  }
  /deep/ .el-upload{
    width:104px;
    height:104px;
    background:rgba(255,255,255,1);
    border:1px solid rgba(226,226,226,1);
    border-radius:4px;
    img{
      width: 48px;
      height: 48px;
      margin: 14px;
    }
    /deep/ .el-message-box{
      width:420px;
      height:240px;
      background:rgba(255,255,255,1);
      border-radius:8px;
    }
    /deep/ .el-upload__text{
      color: rgba(153,153,153,1);
      font-size: 14px;
      margin-top: -15px;
    }
  }
  /deep/ .el-dialog__header{
    font-size: 16px;
    color: #0F0D11;
    text-align: center;
    background: #F5F5F7;
    border-radius: 24px 24px 0px 0px;
  }
  /deep/ .el-dialog__body{
    border-bottom: 1px solid #D2D2D7;
  }

  /deep/ .el-dialog {
    border-radius: 24px !important;
  }

</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_course_module/editCourse/sourceMaterial/uploadMaterial.vue